import React from 'react';
import { 
    TextInput
 } from 'react-native';
import "./Input.css"
import _ from 'lodash';





 export const Input = props => {

    // export type KeyboardType = 'default' | 'email-address' | 'numeric' | 'phone-pad' | 'number-pad' | 'decimal-pad';
    const {placeholder, onChange, title, value, hasError, required, onSubmit, type = "default"} = props
    const onTextChange = (txt) => {
        if(!!onTextChange){ 
            try{
                onTextChange(txt)
            } catch(e) {
                // console.log(e)
            }
        }
    }

    return(
        <div className="input-container">
            <label className="input-title">{title ? title : placeholder}{!required ? <span>&nbsp;( Optional )</span> : ""}</label>
            <TextInput
                placeholder={placeholder}
                keyboardType={type}
                value={value}
                style={{
                    width: '100%',
                    height: 'calc(1.5em + 0.75rem + 2px)',
                    padding: '0.375rem 0.75rem',
                    fontSize: '1rem',
                    fontWeight: 400,
                    lineHeight: 1.5,
                    color: '#495057',
                    backgroundColor: hasError ? "#FF000044" : 'white',
                    border: hasError ? '2px solid #FF0000' : '1px solid #ced4da',
                    borderRadius: '0.25rem',
                    padding: '1rem'
                }}
                underlineColorAndroid="transparent"
                onChangeText={onChange}
                onSubmitEditing={onSubmit}
            />
        </div>
    )

    
 }
